import { Trans, useTranslation, UseTranslationOptions } from "react-i18next";
import { PropsWithChildren } from "react";
import { Heading, HeadingProps, Text, TextProps } from "@radix-ui/themes";
import classNames from "classnames";

// Prefer to use TranslatedText, since it covers preventing google translate from overwriting these translations, but
// sometimes it's necessary to have access to the root hook.
export function useT(i18nOptions: UseTranslationOptions<string> = {}) {
  return useTranslation("translation", i18nOptions).t;
}

export function TranslatedText(
  props: PropsWithChildren<
    {
      i18nOptions?: UseTranslationOptions<string>;
    } & (TextProps | HeadingProps)
  >,
) {
  const { i18nOptions = {}, ...rest } = props;
  const t = useT(props.i18nOptions);

  const className = classNames("no-translate", props.className || "");

  const sub = (
    <Trans t={t} {...i18nOptions}>
      {props.children}
    </Trans>
  );

  if (rest.as && ["h1", "h2", "h3", "h4", "h5", "h6"].includes(rest.as)) {
    return (
      <Heading {...(rest as HeadingProps)} className={className}>
        {sub}
      </Heading>
    );
  } else {
    return (
      <Text {...(rest as TextProps)} className={className}>
        {sub}
      </Text>
    );
  }
}
